import script from "./KnowledgeBase.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBase.vue?vue&type=style&index=0&id=fdad6a88&scoped=true&lang=css"
import "./KnowledgeBase.vue?vue&type=style&index=1&id=fdad6a88&lang=css"
import "./KnowledgeBase.vue?vue&type=style&index=2&id=fdad6a88&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdad6a88"]])

export default __exports__